import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Brand } from '../interfaces/brand';
import { STOREFRONT_WAREHOUSE_ID } from '../config/storefront.config';
// لو عامل الموديل اللي كتبناه قبل كده

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  private baseUrl = `${environment.Server_URL}/brands`;

  constructor(private http: HttpClient) { }


  getAllBrands(isLocalBrand?: 0 | 1): Observable<any> {
    let params: any = {
      warehouse_id: STOREFRONT_WAREHOUSE_ID
    };

    if (isLocalBrand !== undefined) {
      params.is_local_brand = isLocalBrand;
    }

    return this.http.get<any>(`${this.baseUrl}/all`, { params });
  }

}
